import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SideMenuSubItem {
    key: string;
    displayName: string;
    visibleToRoles: string[];
    visibleToProducts?: string[];
    availability: 'online' | 'offline' | 'both';
    icon?: string;
    onClickAction?: string;
    activeIcon?: string;
    inactiveIcon?: string;
}

interface SideMenuItem {
    key: string;
    displayName: string;
    visibleToRoles: string[];
    visibleToProducts?: string[];
    availability: 'online' | 'offline' | 'both';
    icon?: string;
    subItems: SideMenuSubItem[];
}

interface SideBarConfigState {
    success: boolean;
    data: {
        sideNavItems: SideMenuItem[];
    };
}

const initialState: SideBarConfigState = {
    data: { sideNavItems: [] },
    success: false,
};

const sideBarConfigSlice = createSlice({
    name: 'sideBarConfig',
    initialState,
    reducers: {
        setSideBarConfig: (
            state,
            action: PayloadAction<SideBarConfigState>
        ) => {
            state.data = action.payload.data;
            state.success = action.payload.success;
        },
    },
});

export const { setSideBarConfig } = sideBarConfigSlice.actions;

export default sideBarConfigSlice.reducer;
